import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export const TextSearchComponent = ({
  searchRef = null,
  searchStyleClass = "w-full min-w-80 max-w-96 p-2 justify-between text-sm",
  iconClass = "left-6 w-4",
  placeholder = "Search",
  searchTerm = "",
  setSearchTerm = () => {},
  autoFocus = false,
  padding = "py-3",
  onFocus = () => {},
}) => {
  return (
    <div
      ref={searchRef}
      className={`${searchStyleClass} ${padding} flex items-center gap-2 border-card-width text-grey-600  px-4 md:pr-3 rounded-3xl focus-within:border-primary bg-white`}
    >
      <MagnifyingGlassIcon className={`${iconClass} text-grey-600`} />
      <input
        name="Search"
        autoFocus={autoFocus}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        className="w-full bg-transparent focus:outline-none"
        onFocus={onFocus}
      />
    </div>
  );
};
